import type { PanelOrganizationOwnerDto } from '@icebreaker/shared';

/**
 * Sahip satırının panel görünümü. Sunucu `PANEL_OWNER_STATES` döner;
 * sahip satırı hiç yoksa (iptal sonrası) `none`. "Açıldı" durumu sunucuda
 * izlenmediği için burada da YOKTUR (uydurma veri yok).
 */
export type OwnerViewKind = 'active' | 'invited' | 'expired' | 'declined' | 'revoked' | 'none';

export interface OwnerView {
  readonly kind: OwnerViewKind;
  readonly name: string | null;
  readonly email: string | null;
}

export function ownerView(owner: PanelOrganizationOwnerDto | null): OwnerView {
  if (!owner) return { kind: 'none', name: null, email: null };
  return { kind: owner.state, name: owner.displayName, email: owner.email };
}
